"use strict";
//to do, check chat gpt for the updated code,
//chnage the call state when new call is started with noah,
// sign over controls to the new calls with noah
// turn down the valume of the music
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
//import ModalWindow
var ModalWindow_1 = __importDefault(require("./ModalWindow"));
var config_1 = require("../../constants/config");
require("bootstrap/dist/css/bootstrap.min.css");
function ChatWidget() {
    // state variable to track if widget button was hovered on
    var _a = (0, react_1.useState)(false), hovered = _a[0], setHovered = _a[1];
    // state variable to track modal visibility
    var _b = (0, react_1.useState)(false), visible = _b[0], setVisible = _b[1];
    //creating a ref 'id'
    var widgetRef = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)("checking"), micStatus = _c[0], setMicStatus = _c[1];
    var _d = (0, react_1.useState)((0, config_1.getWidgetConfig)().agentName), currentAgentName = _d[0], setCurrentAgentName = _d[1];
    var _e = (0, react_1.useState)('Speak With'), currentStage = _e[0], setCurrentStage = _e[1];
    var _f = (0, react_1.useState)('inactive'), callState = _f[0], setCallState = _f[1];
    var _g = (0, react_1.useState)(null), micStream = _g[0], setMicStream = _g[1];
    // use effect listener to check if the mouse was cliked outside the window 
    (0, react_1.useEffect)(function () {
        function handleClickOutside(event) {
            if (widgetRef.current && !widgetRef.current.contains(event.target)) {
                // setVisible(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [widgetRef]);
    function checkMic() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (navigator.mediaDevices && !visible) {
                    navigator.mediaDevices
                        .getUserMedia({ audio: true, video: false })
                        .then(function (stream) {
                        setMicStream(stream);
                        // Make stream available globally for Retell
                        window.retellMicrophoneStream = stream;
                        setMicStatus("active");
                        setVisible(true);
                    }).catch(function (error) {
                        if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
                            setMicStatus("denied");
                        }
                        else if (error.name === "NotFoundError" || error.name === "DevicesNotFoundError") {
                            setMicStatus("denied");
                        }
                        else {
                            setMicStatus("denied");
                        }
                    });
                }
                else if (visible) {
                    setVisible(false);
                    setCurrentAgentName((0, config_1.getWidgetConfig)().agentName);
                    setCurrentStage('Speak With');
                    stopMicrophone();
                }
                return [2 /*return*/];
            });
        });
    }
    // 🔁 This function allows you to update agent name and manage transfer behavior
    function handleAgentTransfer(newAgentName) {
        setCurrentAgentName((0, config_1.getWidgetConfig)().transferAgentName);
        setCurrentStage('Calling');
        setMicStatus("active");
    }
    (0, react_1.useEffect)(function () {
        window.transferToAgent = handleAgentTransfer;
    }, []);
    // 🔁 This function allows you to update agent name and manage transfer behavior
    function handleAgentHengUp(newAgentName) {
        setCurrentAgentName((0, config_1.getWidgetConfig)().agentName);
        setCurrentStage('Speak With');
        setMicStatus("active");
        setVisible(false);
    }
    (0, react_1.useEffect)(function () {
        window.hengUpAgent = handleAgentHengUp;
    }, []);
    // Function to handle call state changes
    function handleCallStateChange(state) {
        setCallState(state);
    }
    (0, react_1.useEffect)(function () {
        window.setCallState = handleCallStateChange;
        window.muteMicrophone = muteMicrophone;
        window.unmuteMicrophone = unmuteMicrophone;
        window.stopMicrophone = stopMicrophone;
    }, []);
    // Cleanup microphone stream on component unmount
    (0, react_1.useEffect)(function () {
        return function () {
            stopMicrophone();
        };
    }, []);
    // Function to mute the microphone
    var muteMicrophone = function () {
        if (window.retellWebClient) {
            window.retellWebClient.mute();
            //console.('Microphone muted using Retell SDK');
        }
        else {
            console.log('not found');
        }
    };
    // Function to unmute the microphone
    var unmuteMicrophone = function () {
        if (window.retellWebClient) {
            window.retellWebClient.unmute();
            //console.log('Microphone unmuted using Retell SDK');
        }
        else {
            console.log('not found');
        }
    };
    // Function to stop the microphone stream completely
    var stopMicrophone = function () {
        if (micStream) {
            micStream.getTracks().forEach(function (track) {
                track.stop();
            });
            setMicStream(null);
            console.log('Microphone stream stopped');
        }
    };
    var openModal = function () {
        setVisible(true);
    };
    var handleWidgetClick = function () {
        if (callState === 'inactive') {
            // Start call - request microphone access
            checkMic();
            setCallState('active');
        }
        else if (callState === 'active') {
            // End call
            setVisible(false);
            setCurrentAgentName((0, config_1.getWidgetConfig)().agentName);
            setCurrentStage('Speak With');
            stopMicrophone();
            setCallState('offline');
        }
        else if (callState === 'offline') {
            // Start new call
            checkMic();
            setCallState('active');
        }
    };
    return (react_1.default.createElement("div", { ref: widgetRef },
        react_1.default.createElement(ModalWindow_1.default, { visible: visible, setVisible: setVisible }),
        react_1.default.createElement("div", { style: {
                position: 'fixed',
                bottom: 32,
                right: 32,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                cursor: 'pointer',
                zIndex: 1000,
            }, onClick: handleWidgetClick, onMouseEnter: function () { return setHovered(true); }, onMouseLeave: function () { return setHovered(false); } },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 8, // Space between main widget and agent status
                } },
                react_1.default.createElement("div", { style: {
                        width: 56,
                        height: 56,
                        borderRadius: '50%',
                        background: callState === 'active'
                            ? 'transparent'
                            : callState === 'offline'
                                ? '#6B7280'
                                : 'linear-gradient(135deg, #d7c3b4 0%, #bfa897 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease',
                        flexShrink: 0,
                        zIndex: 2, // Above the white background
                        boxShadow: callState === 'active' ? 'none' : '0 4px 12px rgba(0,0,0,0.15)',
                    }, onClick: function (e) {
                        e.stopPropagation();
                        handleWidgetClick();
                    }, onMouseEnter: function (e) {
                        e.currentTarget.style.transform = 'scale(1.05)';
                    }, onMouseLeave: function (e) {
                        e.currentTarget.style.transform = 'scale(1)';
                    } }, callState === 'active' ? (react_1.default.createElement("img", { src: "https://vocodia-maxoderm-multi-widget.pages.dev/Asset/active_call.png", alt: "Active Microphone", width: "59", height: "59", style: {
                        filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))',
                        boxShadow: '0 0 20px rgba(20, 174, 92, 0.8)',
                        animation: 'pulse-green 2s infinite',
                        borderRadius: '50%'
                    } })) : callState === 'offline' ? (react_1.default.createElement("img", { src: "https://vocodia-maxoderm-multi-widget.pages.dev/Asset/mute_call.png", alt: "Offline Microphone", width: "59", height: "59", style: { filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))' } })) : (react_1.default.createElement("img", { src: "https://vocodia-maxoderm-multi-widget.pages.dev/Asset/inactive_call.png", alt: "Available Microphone", width: "59", height: "59", style: { filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))' } }))),
                react_1.default.createElement("div", { style: {
                        width: 176,
                        backgroundColor: '#ffffff',
                        borderRadius: '20px',
                        padding: '5px 20px 6px 35px', // More padding on left to account for mic overlap
                        marginLeft: -28, // Overlap with the mic icon
                        boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
                        border: '1px solid #e0e0e0',
                        animation: 'none',
                        transition: 'all 0.2s ease',
                        transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
                    } },
                    react_1.default.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                        } },
                        react_1.default.createElement("div", { style: {
                                color: '#159895',
                                fontWeight: '600',
                                fontSize: '11px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.3px',
                                lineHeight: 1.1,
                                marginBottom: 1,
                            } }, callState === 'offline' ? 'ASSISTANT' : callState === 'active' ? 'TELL ME HOW' : 'TALK TO OUR '),
                        react_1.default.createElement("div", { style: {
                                color: '#159895',
                                fontWeight: '600',
                                fontSize: '11px',
                                textTransform: 'uppercase',
                                letterSpacing: '0.3px',
                                lineHeight: 1.1,
                            } }, callState === 'offline' ? 'OFFLINE' : callState === 'active' ? 'I CAN HELP' : 'AI ASSISTANT')))),
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: 4,
                    marginRight: 8, // Align with the right edge of the speech bubble
                    marginTop: -11, // Move status text up closer
                } },
                react_1.default.createElement("div", { style: {
                        color: '#999999',
                        fontSize: '9px',
                        fontWeight: '400',
                        textTransform: 'uppercase',
                        letterSpacing: '0.2px',
                    } }, callState === 'active' || callState === 'offline' ? 'CALL STATUS:' : 'AGENT STATUS:'),
                react_1.default.createElement("div", { style: {
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        backgroundColor: callState === 'active'
                            ? '#EC221F'
                            : callState === 'offline'
                                ? '#D1D5DB'
                                : '#2ecc71',
                        flexShrink: 0,
                        animation: callState === 'active' ? 'pulse-red 2s infinite' : 'none',
                    } }),
                react_1.default.createElement("div", { style: {
                        color: '#333333',
                        fontSize: '10px',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        letterSpacing: '0.2px',
                    } }, callState === 'offline' ? 'OFFLINE' : callState === 'active' ? 'NOW ASSISTING' : 'AVAILABLE')))));
}
exports.default = ChatWidget;
